module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/pickup-2-451ea18ec7c0b1550a5fa237c35b0014.png";